/* This file is generated by Kubb. DO NOT EDIT MANUALLY. */

import type { SearchNotificationsMutationRequest } from './types/SearchNotifications.ts';
import type { Client } from '@kubb/plugin-client/clients/fetch';
import { searchNotifications } from './clients/searchNotifications.ts';

export class ApiClient {
  constructor(private readonly client: Client) {}

  searchNotifications(data: SearchNotificationsMutationRequest) {
    return searchNotifications(data, { client: this.client });
  }
}
